import { render, staticRenderFns } from "./propertyEditDetails.vue?vue&type=template&id=4429b6e9"
import script from "./propertyEditDetails.vue?vue&type=script&lang=js"
export * from "./propertyEditDetails.vue?vue&type=script&lang=js"
import style0 from "./propertyEditDetails.vue?vue&type=style&index=0&id=4429b6e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports